import Vue from 'vue'
import Vuex from 'vuex'
import appConsts from './consts.js';
import memberModule from './modules/member.js';
import orderModule from './modules/order.js';
import homeModule from './modules/home.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: '首页',
    showNavbar: true,
    showNavbarLeft: true,
    showNavbarRight: true,
    navbarColor: 'white',
    showTabbar: true,
    tabbarActiveIndex: -1,
    clientHeight: 500,
    wxJsApiConfigedPages: []
  },
  mutations: {
    [appConsts.setTitle](state, value) {
      state.title = value;
    },
    [appConsts.setShowNavbar](state, value) {
      state.showNavbar = value;
    },
    setShowNavbarLeft(state, value) {
      state.showNavbarLeft = value;
    },
    setShowNavbarRight(state, value) {
      state.showNavbarRight = value;
    },
    [appConsts.setNavbarColor](state, value) {
      state.navbarColor = value;
    },
    [appConsts.setShowTabbar](state, value) {
      state.showTabbar = value;
    },
    [appConsts.activeTabbar](state, index) {
      state.tabbarActiveIndex = index;
    },
    setClientHeight(state, value) {
      state.clientHeight = value;
    },
    setPageConfiged(state, pageName) {
      if (state.wxJsApiConfigedPages.includes(pageName)) return;
      state.wxJsApiConfigedPages.push(pageName);
    }
  },
  modules: {
    homeModule: homeModule,
    memberModule: memberModule,
    orderModule: orderModule
  }
})